// import './helpers/wdyr'; // Why did you render component import
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store';
import './index.scss';

const styleCache = createCache({
	key: 'sdq',
	nonce: 'w51UFM0uev/LhCA+J2h7Bw==',
});

function renderApp() {
	ReactDOM.render(
		<React.StrictMode>
			<Provider store={store}>
				<CacheProvider value={styleCache}>
					<Router>
						<App />
					</Router>
				</CacheProvider>
			</Provider>
		</React.StrictMode>,
		document.getElementById('root')
	);
}

// Fetch theme config, set CSS variables, then render the app
fetch('/theme-config.json')
	.then(res => res.json())
	.then(config => {
		const root = document.documentElement;
		root.style.setProperty('--primary', config.primaryColor);
		root.style.setProperty('--secondary', config.secondaryColor);
		root.style.setProperty('--font-family', config.fontFamily);
		root.style.setProperty('--table-header-background-color', config.tableHeaderBackgroundColor);
		root.style.setProperty('--table-header-color', config.tableHeaderColor);
		root.style.setProperty('--table-even-row-background-color', config.tableEvenRowBackgroundColor);
		root.style.setProperty('--table-odd-row-background-color', config.tableOddRowBackgroundColor);
		root.style.setProperty('--button-primary-color', config.buttonPrimaryColor);
		root.style.setProperty('--button-primary-background-color', config.buttonPrimaryBackgroundColor);
		root.style.setProperty('--button-primary-border-color', config.buttonPrimaryBorderColor);
		root.style.setProperty('--button-secondary-color', config.buttonSecondaryColor);
		root.style.setProperty('--button-secondary-background-color', config.buttonSecondaryBackgroundColor);
		root.style.setProperty('--button-secondary-border-color', config.buttonSecondaryBorderColor);
		renderApp();
	})
	.catch(() => {
		// If fetch fails, render app with default theme
		renderApp();
	});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
